import { render, staticRenderFns } from "./ShippingLocalDocument.vue?vue&type=template&id=6f32aa38&scoped=true"
import script from "./ShippingLocalDocument.vue?vue&type=script&lang=js"
export * from "./ShippingLocalDocument.vue?vue&type=script&lang=js"
import style0 from "./ShippingLocalDocument.vue?vue&type=style&index=0&id=6f32aa38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f32aa38",
  null
  
)

export default component.exports